import { RolePerformerType } from './role-performer-types';

/**
 * Role Type
 */
export enum RoleType {
  Actor = 'Actor',
  Speaker = 'Speaker',
  Narrator = 'Narrator',
  Announcer = 'Announcer',
  Singer = 'Singer',
  SpecialtyDancer = 'Specialty Dancer',
  SpecialtyAct = 'Specialty Act',
  Puppeteer = 'Puppeteer',
  StuntPerformer = 'Stunt Performer',
  StuntCoordinator = 'Stunt Coordinator',
  Pilot = 'Pilot',
  Clown = 'Clown',
  StandIn = 'Stand In',
  HandModel = 'Hand Model',
  HandModelDoubleScale = 'Hand Model Double Scale',
  Other = 'Other',
  LeaderArrangerComposer = 'Leader Arranger Composer',
  CopyistSideMusician = 'Copyist Side Musician',
  CopyistSideMusician1Double = 'Copyist Side Musician 1 Double',
  CopyistSideMusician2Doubles = 'Copyist Side Musician 2 Doubles',
  CopyistSideMusician3Doubles = 'Copyist Side Musician 3 Doubles',
  CopyistSideMusician4Doubles = 'Copyist Side Musician 4 Doubles',
}

export enum RoleScale {
  SessionScale = 'Session Scale',
  AboveScale = 'Above Scale',
}

/**
 * Type Lists
 */
export const OnCameraPrincipalTypes = [
  RoleType.Actor,
  RoleType.Singer,
  RoleType.SpecialtyDancer,
  RoleType.SpecialtyAct,
  RoleType.StuntPerformer,
  RoleType.Pilot,
  RoleType.Clown,
];

export const OffCameraPrincipalTypes = [
  RoleType.Narrator,
  RoleType.Announcer,
  RoleType.Puppeteer,
  RoleType.StuntCoordinator,
];

export const ExtraTypes = [
  RolePerformerType.Extra,
  RoleType.Actor,
  RoleType.StandIn,
  RoleType.Singer,
  RoleType.HandModel,
  RoleType.HandModelDoubleScale,
  RoleType.SpecialtyDancer,
  RoleType.SpecialtyAct,
  RoleType.StuntPerformer,
  RoleType.Pilot,
  RoleType.Clown,
];

export const AFMTypes = [
  RoleType.LeaderArrangerComposer,
  RoleType.CopyistSideMusician,
  RoleType.CopyistSideMusician1Double,
  RoleType.CopyistSideMusician2Doubles,
  RoleType.CopyistSideMusician3Doubles,
  RoleType.CopyistSideMusician4Doubles,
];

export const TVTypes = [
  ...OnCameraPrincipalTypes,
  ...OffCameraPrincipalTypes,
  ...ExtraTypes,
  ...AFMTypes,
];

export const RadioTypes = [
  RoleType.Announcer,
  // ...AFMTypes // this line was in the client's version
];

/**
 * All Role/Performer Types
 */
export const RoleFilter: Record<string, string[]> = {
  [RolePerformerType.OnCameraPrincipal]: OnCameraPrincipalTypes,
  [RolePerformerType.OnCameraGroup]: OnCameraPrincipalTypes,
  [RolePerformerType.OffCameraPrincipal]: OffCameraPrincipalTypes,
  [RolePerformerType.OffCameraGroup]: OffCameraPrincipalTypes,
  [RolePerformerType.Extra]: ExtraTypes,
  [RolePerformerType.Radio]: RadioTypes,
  [RolePerformerType.AFM]: AFMTypes,
};
